// contact-form.js — preserved for reference; Shopify native contact forms now handle submissions
// with built-in hCaptcha. No custom AJAX interception needed.
(function () {
  var spForm = document.getElementById('sp_form');
  if (!spForm) return;

  const base_url = 'https://proweaveremail.com/shopifysendingemail/';
  const test_mode = true;
  const company_name = 'Proweaver Shopify Template';
  const company_email = 'spproweaver@gmail.com';
  const email = test_mode ? 'prospteam@gmail.com' : company_email;

  const submitBtn = spForm.querySelector('[type="submit"]');

if (test_mode) {
    submitBtn.disabled=true;

    // Wrap submit button for tooltip
    const wrapper = document.createElement('div');
    wrapper.classList.add('submit-wrapper', 'test-mode-active');
    submitBtn.parentNode.insertBefore(wrapper, submitBtn);
    wrapper.appendChild(submitBtn);

} else {
    submitBtn.disabled=false;
}

  $(document).on('submit', '#sp_form', function (e) {
    e.preventDefault();

    $('#prompt_message').text('');

    const consentChecked = $(this).find('input[type="checkbox"]').is(':checked');

    if (!consentChecked) {
        $('#prompt_message').removeClass('success-prompt');
        $('#prompt_message').addClass('error-prompt');
        $('#prompt_message').text('Please agree to the consent clause before submitting');
        return;
    }

    const formdata = new FormData($(this)[0]);
    const form_name = `${company_name} | ${$(this).attr('form-name')}`;

    formdata.append('form_name', form_name);
    formdata.append('company_name', company_name);
    formdata.append('email', email);

    $.ajax({
        url: base_url,
        type: 'POST',
        data: formdata,
        dataType: 'json',
        processData: false,
        contentType: false,
        beforeSend: function () {
            $(`#sp_form input[type='submit']`).val('Sending...');
            $(`#sp_form input[type='submit']`).prop('disabled', true);
        },
        success: function (response) {
            $('#prompt_message').removeClass('error-prompt');
            $('#prompt_message').addClass('success-prompt');
            $('#prompt_message').html(response);
            $('#sp_form')[0].reset();
        },
        error: function (xhr, status, error) {

            let message = 'Something went wrong. Please try again.';

            if (xhr.responseJSON && xhr.responseJSON.message) {
                message = `${xhr.responseJSON.message}`;
            }

            $('#prompt_message').removeClass('success-prompt');
            $('#prompt_message').addClass('error-prompt');
            $('#prompt_message').text(message);
            $(`#sp_form input[type='submit']`).prop('disabled', false);
        },
        complete: function () {
            $(`#sp_form input[type='submit']`).val('Send');
            $(`#sp_form input[type='submit']`).prop('disabled', false);
        }
    });
  });

})();